import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getDealersUserById, defaultDealersUserData, updateDealersUser, register, getDealersUsers } from '@/api/dealers-users';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import FileUpload from '@/components/FileUpload/index.vue';
import { getQuery } from '@/utils';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.avatar = [];
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, defaultDealersUserData);
    this.loading = false;
    this.validateMobileNumber = (rule, value, callback) => {
      if (!value) {
        callback(new Error('Mobile number is required'));
      } else if (!/^\d{10}$/.test(value)) {
        callback(new Error('Please enter exactly 10 digits'));
      } else {
        callback();
      }
    };
    this.rules = {
      fullName: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      // emailAddress: [
      //   { required: true, message: "This field is required", trigger: "blur" },
      //   {
      //     type: "email",
      //     required: true,
      //     message: "Please enter valid email",
      //     trigger: "change",
      //   },
      // ],
      mobileNumber: [{
        required: true,
        message: 'Mobile number is required',
        trigger: 'blur'
      }, {
        validator: this.validateMobileNumber,
        trigger: 'blur'
      }, {
        pattern: /^[0-9]{10}$/,
        message: 'Only numbers allowed, must be 10 digits',
        trigger: 'blur'
      }, {
        pattern: /^\d+$/,
        message: 'Please enter numbers only',
        trigger: 'blur'
      }, {
        min: 10,
        max: 10,
        message: 'Length should be 10 only',
        trigger: ['blur']
      }],
      password: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }, {
        min: 6,
        message: 'Length should be of minimum 8 characters',
        trigger: ['blur']
      }],
      dealerId: [{
        required: true,
        message: 'This field is required',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      const id = parseInt(this.$route.params && this.$route.params.id);
      this.fetchData(id);
    } else {
      this.formData = Object.assign({}, defaultDealersUserData);
      this.formData.dealerId = parseInt(this.$route.params && this.$route.params.dealerId);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getDealersUserById(id);
      this.formData = data;
      // set avatar
      this.avatar.push({
        name: data.name,
        url: data.avatar
      });
      const title = this.formData.fullName;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  async checkIfNumberExists() {
    // check if number exists
    if (!this.isEdit) {
      const query = {
        mobileNumber: this.formData.mobileNumber,
        filter: {
          mobileNumber: '$eq'
        }
      };
      if (this.formData.mobileNumber !== '') {
        const user = await getDealersUsers(getQuery(query));
        if (user.length > 0) {
          this.$notify.error({
            title: 'Error',
            message: 'Mobile number already exists'
          });
        }
      }
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  fileUploaded(file) {
    this.formData.avatar = file.response;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      this.formData.dealer = {
        id: this.formData.dealerId
      };
      if (this.isEdit) {
        // update user
        await updateDealersUser(this.formData.id, this.formData);
      } else {
        await register(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Dealers User added successfully',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/dealers-users/list/' + this.formData.dealerId
      });
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'DealersUserDetail',
  components: {
    FileUpload
  }
})], default_1);
export default default_1;